// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"329":"openai","342":"hunspell","614":"turndown"}[chunkId] || chunkId) + "." + chunkId + "." + {"88":"287cf53477a17fedc65d","170":"104d2ab70cf5a82da229","329":"a3d412b8cbd868dee97b","342":"28862351fc8e8ae19429","614":"074edf8b79089f8ceaa6","972":"ce83ebada53f815cdbb6"}[chunkId] + ".bundle.js";
};